<template>
  <div class="c-order-name-id">
    <p class="order">{{ formatTrackNumber }}</p>
    <div class="info">
      <p class="info__name">{{ data?.trackTitleDisplay || '' }}</p>
      <p class="info__id">{{ data?.albumCode }}-{{ data?.trackNumber }}</p>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import { handleComplexTrackNumber } from '@/utils/helper';

export default defineComponent({
  name: 'AlbumOrderNameId',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    idx: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const formatTrackNumber = computed(() => {
      const { trackNumber } = props.data;
      const tempStr = handleComplexTrackNumber(trackNumber);

      return tempStr;
    });

    return {
      formatTrackNumber,
    };
  },
});

</script>
<style lang="scss" scoped>
.c-order-name-id {
  @include flex();

}

.order {
  @include font-style($c-assist3, 14, bold, 0.8px, 26px);
}

.info {
  margin-left: 12px;

  &__name {
    @include font-style($c-assist6, 14, bold, 0px, 24px);
    @include word-ellipsis();
  }

  &__id {
    @include font-style($c-assist4, 14, 400, 0px, 24px);
  }
}
</style>
